import { useMutation, MutationHookOptions } from '@apollo/client';
import { RETRY_PFA_BOOST_REWARD_MUTATION } from '../queries/retryPFABoostRewardMutation';
import { RetryPFABoostReward, RetryPFABoostRewardVariables } from '../queries/types/RetryPFABoostReward';

type TOptions = MutationHookOptions<RetryPFABoostReward, RetryPFABoostRewardVariables>;

export const useRetryPFABoostReward = (options: TOptions = {}) =>
  useMutation<RetryPFABoostReward, RetryPFABoostRewardVariables>(RETRY_PFA_BOOST_REWARD_MUTATION, options);
